module.exports = __webpack_public_path__ + "assets/chevron-left-e3f0abe77e9a3ca642d993d6adc2d64f.svg";